import React from "react";
import "../../members/screens/MemberPrint.css";
import { formatISODateToLocalDMY } from "../../../utils/utils";

const NomineeAuthorizationLetter = ({ memberDetails }) => {
  const currentDate = formatISODateToLocalDMY(new Date());

  return (
    <div className="section sanction-letter-section m-5">
      <h1 className="text-center">Nomination Authorization Letter</h1>

      <div className="text-end">
        <b>Date: {currentDate}</b>
      </div>

      <div style={{ fontSize: "16px" }}>
        <b>From</b>
        <br />
        <br />
        <span>{memberDetails.memberDetails.memberName || ""}</span>
        <br />
        <span>
          {memberDetails.memberDetails.permanentDoorNo +
            "," +
            memberDetails.memberDetails.permanentStreetNo +
            "," +
            memberDetails.memberDetails.permanentPanchayat +
            "," +
            memberDetails.memberDetails.permanentTaluk}
        </span>
        <br />
        <span>
          {memberDetails.memberDetails.permanentDistrict +
            " " +
            memberDetails.memberDetails.permanentPincode}
        </span>
      </div>

      <div style={{ fontSize: "16px" }}>
        <b>To,</b>
        <br />
        <br />
        <span>The Management</span>
        <br />
        <span>Vetrivikas capital Trust</span>
        <br />
        <span>Madurai</span>
      </div>

      <div style={{ fontSize: "20px" }}>
        <br />
        <b>Subject: Nomination Authorization Letter</b>
      </div>

      <div>
        <br />
        <span>
          <b>Loan Account Number:</b>&nbsp;&nbsp;
          {memberDetails.memberDetails.ApplicationId || ""}
        </span>
        <br />
        <span>
          <b>Customer Name: </b>&nbsp;&nbsp;
          {memberDetails.memberDetails.memberName || ""}
        </span>
        <br />
        <span>
          <b>Customer Address:</b>&nbsp;&nbsp;
          {memberDetails.memberDetails.permanentDoorNo +
            "," +
            memberDetails.memberDetails.permanentStreetNo +
            "," +
            memberDetails.memberDetails.permanentPanchayat +
            "," +
            memberDetails.memberDetails.permanentTaluk +
            "," +
            memberDetails.memberDetails.permanentDistrict +
            " " +
            memberDetails.memberDetails.permanentPincode}
        </span>
        <br />
        <span>
          <b> Contact Number: </b>&nbsp;&nbsp;
          {memberDetails.memberDetails.phoneNumber || ""}
        </span>
      </div>

      <div>
        <br />
        <span>Dear Sir/Madam,</span>
      </div>

      <div>
        <br />
        <p>
          I, the undersigned, hereby nominate the following person as the
          nominee in respect of the gold held in custody under the
          above-referenced gold loan account. In the unfortunate event of my
          demise or if I become temporarily incapacitated (due to an accident,
          illness, pregnancy, or any other reason) during the loan tenure or
          before the release of the gold, I authorize the company to release the
          custody of the ornaments to the nominee mentioned below, subject to
          the repayment of the outstanding loan amount, accrued interest, and
          any other applicable charges.
        </p>
      </div>

      <div>
        <p>Nominee Details:</p>
        <ul>
          <li>
            <b>Full Name:</b>&nbsp;&nbsp;
            {memberDetails.coApplicantDetails.coApplicantName || ""}
          </li>
          <li>
            <b>Relationship with Customer:</b>&nbsp;&nbsp;
            {memberDetails.coApplicantDetails.relation || ""}
          </li>
          <li>
            <b>Date of Birth:</b> &nbsp;&nbsp;
            {memberDetails.coApplicantDetails.dateOfBirth || ""}
          </li>
          <li>
            <b>Address:</b> &nbsp;&nbsp;
            {memberDetails.coApplicantDetails.permanentDoorNo +
              "," +
              memberDetails.coApplicantDetails.permanentStreetNo +
              "," +
              memberDetails.coApplicantDetails.permanentPanchayat +
              "," +
              memberDetails.coApplicantDetails.permanentTaluk +
              "," +
              memberDetails.coApplicantDetails.permanentDistrict +
              " " +
              memberDetails.coApplicantDetails.permanentPincode}
          </li>
          <li>
            <b>Phone Number:</b> &nbsp;&nbsp;
            {memberDetails.coApplicantDetails.phoneNumber || ""}
          </li>
          <li>
            <b>Aadhaar/PAN (if available):</b> &nbsp;&nbsp;
            {memberDetails.coApplicantDetails.aadharNo || ""}
          </li>
        </ul>
      </div>

      <div>
        <p>
          I understand that the nominee shall have no right to the gold or claim
          any benefit unless the loan is duly settled as per the terms and
          conditions of the loan agreement. This nomination shall remain valid
          until specifically revoked by me in writing.
        </p>
        <p className="text-center">Thank you.</p>
      </div>

      <div className="letter-signature">
        <p>Sincerely,</p>
        <div className="signature-block">
          <div className="signature-line"></div>
          <p>{memberDetails.memberDetails.memberName || ""}</p>
          <p>{memberDetails.memberDetails.customerId}</p>
        </div>
      </div>
    </div>
  );
};

export default NomineeAuthorizationLetter;
